import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../colorVars';
import { AuxPanelContents } from './AuxPanelContents';
import { AuxPanelSwitch } from './AuxPanelSwitch';

export const AuxPanel = ({ tradePlanId }) => {
  const [selection, setSelection] = useState('bidAsk');

  return (
    <div
      style={{
        maxHeight: '100%',
        maxWidth: '165px',
        minWidth: '165px',
        marginLeft: '5px',
        marginTop: '5px',
        backgroundColor: colors.grey,
        paddingTop: '5px',
        marginRight: '5px'
      }}
    >
      <AuxPanelSwitch selection={selection} setSelection={setSelection} />
      <AuxPanelContents tradePlanId={tradePlanId} selection={selection} />
    </div>
  );
};

AuxPanel.propTypes = {
  tradePlanId: PropTypes.string,
};
